import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Youtube } from "lucide-react";
import { Button } from "@/components/ui/button";
import robAvatar from "@/assets/rob-avatar.jpeg";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Journal", path: "/journal" },
    { name: "The Nice Guy Trap", path: "/nice-guy" },
    { name: "Connect", path: "/connect" },
  ];
  const isActive = (path: string) => location.pathname === path;
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-secondary/95 backdrop-blur-sm border-b border-secondary-foreground/10">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img src={robAvatar} alt="Rob Lasa" className="w-10 h-10 rounded-full object-cover" />
            <span className="text-2xl text-accent tracking-wider uppercase font-bold font-display">ROB LASA</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-secondary-foreground/80 hover:text-accent transition-colors font-medium ${isActive(link.path) ? "text-accent" : ""}`}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild size="sm" className="bg-[#FF0000] text-white hover:bg-[#CC0000] gap-2">
              <a href="https://www.youtube.com/@souldadrob" target="_blank" rel="noopener noreferrer">
                <Youtube className="w-4 h-4" />
                YouTube
                <span className="sr-only"> (opens in a new tab)</span>
              </a>
            </Button>
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-secondary-foreground p-2" aria-label="Toggle menu">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 space-y-4 animate-fade-in">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block text-secondary-foreground/80 hover:text-accent transition-colors font-medium py-2 ${isActive(link.path) ? "text-accent" : ""}`}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild size="sm" className="bg-[#FF0000] text-white hover:bg-[#CC0000] w-full gap-2">
              <a href="https://www.youtube.com/@souldadrob" target="_blank" rel="noopener noreferrer">
                <Youtube className="w-4 h-4" />
                YouTube
                <span className="sr-only"> (opens in a new tab)</span>
              </a>
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};
